import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import  api from "../../api";

export default function AdminCustomerProfileEdit () {
  const [profile, setProfile] = useState(null);
  const [formData, setFormData] = useState({});
  const [profileImage, setProfileImage] = useState(null);
  const [orgLogo, setOrgLogo] = useState(null);
  const [profileImagePreview, setProfileImagePreview] = useState(null);
  const [orgLogoPreview, setOrgLogoPreview] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const { id } = useParams();

  // --- گرفتن پروفایل بر اساس ID ---
  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        navigate("/user-login/");
        return;
      }

      if (!id) {
        console.warn("No profile id provided in route params");
        navigate("/admin/users/");
        return;
      }

      try {
        const response = await api.get(`/accounts/admin-customer-profiles/${id}/`);
        setProfile(response.data);
        setFormData(response.data);

        if (response.data.profile_picture) {
          setProfileImagePreview(response.data.profile_picture);
        }
        if (response.data.org_logo) {
          setOrgLogoPreview(response.data.org_logo);
        }
      } catch (error) {
        console.error("خطا در گرفتن پروفایل:", error);
        if (error.response?.status === 401) {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          navigate("/login/");
        } else if (error.response?.status === 404) {
          alert("پروفایل پیدا نشد");
          navigate("/admin/users/");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [id, navigate]);

  // --- تغییر فیلدها ---
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // --- تغییر عکس‌ها ---
  const handleImageChange = (e, setImageFunction, setPreviewFunction) => {
    const file = e.target.files[0];
    if (file) {
      setImageFunction(file);
      const reader = new FileReader();
      reader.onload = (e) => setPreviewFunction(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  // --- ارسال فرم ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("accessToken");

      const submitData = new FormData();
      const textFields = [
        'full_name', 'email', 'birth_date', 'national_id', 'secondary_phone',
        'description', 'is_legal_entity', 'org_name', 'economic_code',
        'national_legal_id', 'registration_id', 'province', 'city',
        'office_phone', 'org_email', 'representative_name', 'representative_phone'
      ];

      textFields.forEach(key => {
        if (formData[key] !== null && formData[key] !== undefined) {
          submitData.append(key, formData[key] || '');
        }
      });

      if (profileImage instanceof File) {
        submitData.append('profile_picture', profileImage);
      } else if (formData.profile_picture === null) {
        submitData.append('profile_picture', '');
      }

      if (orgLogo instanceof File) {
        submitData.append('org_logo', orgLogo);
      } else if (formData.org_logo === null) {
        submitData.append('org_logo', '');
      }

      await api.put(`/accounts/admin-customer-profiles/${id}/`, submitData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      alert("پروفایل با موفقیت ویرایش شد");
      navigate("/admin-panel/user-management/");
    } catch (error) {
      console.error("خطا در ذخیره پروفایل:", error);
      console.error("داده‌های خطا:", error.response?.data);
      alert("خطا در ذخیره اطلاعات. لطفاً دوباره تلاش کنید.");
    }
  };

  // --- حذف عکس ---
  const handleRemoveImage = (type) => {
    if (type === 'profile') {
      setProfileImage(null);
      setProfileImagePreview(null);
      setFormData(prev => ({ ...prev, profile_picture: null }));
    } else if (type === 'org_logo') {
      setOrgLogo(null);
      setOrgLogoPreview(null);
      setFormData(prev => ({ ...prev, org_logo: null }));
    }
  };

  const renderInput = (label, name, type = "text", placeholder = "", colSpan = 1) => (
    <div className={`flex flex-col ${colSpan === 2 ? 'col-span-2' : ''}`}>
      <label className="text-sm font-medium text-gray-700 mb-2">{label}</label>
      <input
        type={type}
        name={name}
        value={formData[name] || ""}
        onChange={handleChange}
        placeholder={placeholder}
        className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      />
    </div>
  );

  const renderTextarea = (label, name, placeholder = "", rows = 3) => (
    <div className="col-span-2 flex flex-col">
      <label className="text-sm font-medium text-gray-700 mb-2">{label}</label>
      <textarea
        name={name}
        value={formData[name] || ""}
        onChange={handleChange}
        placeholder={placeholder}
        rows={rows}
        className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
      />
    </div>
  );

  if (loading) return (
    <div className="flex justify-center items-center h-64">
      <p className="text-lg text-gray-600">در حال بارگذاری...</p>
    </div>
  );



  return (
    <div className="p-6 max-w-4xl mx-auto bg-white rounded-xl shadow-lg">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">ویرایش پروفایل مشتری</h2>

      <form onSubmit={handleSubmit} className="space-y-8">
        {/* بخش عکس پروفایل */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">عکس پروفایل</h3>
          <div className="flex items-center gap-6">
            <div className="relative">
              <img
                src={profileImagePreview || profile.profile_picture || "/images/default-avatar.png"}
                alt="پروفایل"
                className="w-20 h-20 rounded-full object-cover border-2 border-gray-300"
              />
              {(profileImagePreview || profile.profile_picture) && (
                <button
                  type="button"
                  onClick={() => handleRemoveImage('profile')}
                  className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600"
                >
                  ×
                </button>
              )}
            </div>
            <div className="flex-1">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleImageChange(e, setProfileImage, setProfileImagePreview)}
                className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              />
              <p className="text-xs text-gray-500 mt-1">فرمت‌های مجاز: JPG, PNG, GIF - حداکثر سایز: 2MB</p>
            </div>
          </div>
        </div>

        {/* اطلاعات اصلی */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">اطلاعات اصلی</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {renderInput("نام و نام خانوادگی *", "full_name", "text", "نام و نام خانوادگی")}
            {renderInput("ایمیل", "email", "email", "آدرس ایمیل")}
            {renderInput("تاریخ تولد", "birth_date", "date")}
            {renderInput("کد ملی", "national_id", "text", "کد ملی ۱۰ رقمی")}
            {renderInput("شماره موبایل دوم", "secondary_phone", "tel", "شماره موبایل دوم")}
            {renderTextarea("توضیحات", "description", "درباره خود و فعالیت‌هایتان بنویسید...")}
          </div>
        </div>

        {/* شخصیت حقوقی */}
        <div className="border border-gray-200 rounded-lg p-6">
          <div className="flex items-center gap-3 mb-4">
            <input
              type="checkbox"
              name="is_legal_entity"
              checked={formData.is_legal_entity || false}
              onChange={handleChange}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
            />
            <label className="text-lg font-semibold text-gray-800">شخصیت حقوقی</label>
          </div>

          {formData.is_legal_entity && (
            <div className="space-y-6 mt-4">
              {/* لوگوی سازمان */}
              <div className="flex items-center gap-6 p-4 bg-gray-50 rounded-lg">
                <div className="relative">
                  <img
                    src={orgLogoPreview || profile.org_logo || "/images/default-org.png"}
                    alt="لوگوی سازمان"
                    className="w-16 h-16 rounded object-cover border border-gray-300"
                  />
                  {(orgLogoPreview || profile.org_logo) && (
                    <button
                      type="button"
                      onClick={() => handleRemoveImage('org_logo')}
                      className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600"
                    >
                      ×
                    </button>
                  )}
                </div>
                <div className="flex-1">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImageChange(e, setOrgLogo, setOrgLogoPreview)}
                    className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                  />
                  <p className="text-xs text-gray-500 mt-1">لوگوی سازمان</p>
                </div>
              </div>

              {/* اطلاعات سازمان */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {renderInput("نام سازمان *", "org_name", "text", "نام کامل سازمان")}
                {renderInput("کد اقتصادی", "economic_code", "text", "کد اقتصادی")}
                {renderInput("شناسه ملی *", "national_legal_id", "text", "شناسه ملی")}
                {renderInput("شماره ثبت *", "registration_id", "text", "شماره ثبت")}
                {renderInput("استان *", "province", "text", "استان")}
                {renderInput("شهر *", "city", "text", "شهر")}
                {renderInput("تلفن ثابت", "office_phone", "tel", "تلفن ثابت دفتر")}
                {renderInput("ایمیل سازمانی", "org_email", "email", "ایمیل سازمانی")}
                {renderInput("نام مدیر عامل / نماینده", "representative_name", "text", "نام کامل مدیر عامل")}
                {renderInput("شماره موبایل مدیر عامل", "representative_phone", "tel", "شماره موبایل مدیر عامل")}
              </div>
            </div>
          )}
        </div>

        {/* دکمه‌های اقدام */}
        <div className="flex gap-4 justify-end pt-6 border-t border-gray-200">
          <button
            type="button"
            onClick={() => navigate("/admin-panel/user-management/")}
            className="px-8 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors font-medium"
          >
            انصراف
          </button>
          <button
            type="submit"
            className="px-8 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium"
          >
            ذخیره تغییرات
          </button>
        </div>
      </form>
    </div>
  );
};

